




<div class="container payment_cls">




    <div class="alert alert-success" role="alert" *ngIf="bool_success">
        {{reciveuserstatus}}
      </div>

    <div class="alert alert-danger" role="alert" *ngIf="bool_failure">
        {{reciveuserstatus}}
      </div>
  
    <div class="container" >
        <div class="row d-flex justify-content-center">
            <div class="col-md-4 ">
           

               

                   <!--FORM3 Start-->
                  <div class="card-body" *ngIf="bool_itiForm">
                    <!-- <h2>SINGLE / BULK</h2> -->
                      <form [formGroup]="itiForm" (ngSubmit)="onItiSubmit()">
                          <div class="form-row">
                            <div class="form-group col-12">
                                <label>MIS Code <span class="clr_red"> * </span></label>
                                <input type="text" formControlName="iticode" [(ngModel)]="reciveiticode" class="form-control"  
                                    />

                               
                            </div>
                             

                          </div>
                          <hr>
                          <div class="form-row">
                              <div class="form-group col-12">
                                  <div class="text-center">
                                      <button class="btn btn-primary mr-1">Click to select candidates </button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
                  <!--FORM3 End-->
            </div>
        </div>
    </div>



    <div class="card-body" *ngIf="bool_table">
        <div class="row pad-tb-10">
            <div class="col-md-3">
                <span class="fnt-21">Total Candidates Selected: {{total_student}}  </span>
            </div>
            <div class="col-md-3">
                <span class="fnt-21">  Fees Amount: {{total_amount}}</span>
            </div>
            <div class="col-md-6 align-right">
                <button class="btn btn-warning btn-sm btn-white" (click)="onItiApiRefresh()"> Import Candidates </button>
                <button class="btn btn-success btn-sm btn-white" (click)="viewMaster()"> Verify Your Previous Payments  </button>
            </div>
        </div>

    
        <div class="example-container mat-elevation-z8 tableStud">
            <mat-table #table [dataSource]="dataSource" matSort>
    
                <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
    <!--[checked]="selected_family_member.hasValue() && isAllSelected()"-->
                     <!-- Position Column -->
                <ng-container matColumnDef="select" class="mat-column-username">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>  
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="isAllSelected()"
                        [indeterminate]="selected_family_member.hasValue() && !isAllSelected()"> Select All
                    </mat-checkbox> 
                </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selected_family_member.toggle(element) : null"
                        [checked]="selected_family_member.isSelected(element)">
          </mat-checkbox>
                    </mat-cell>
                    
                </ng-container>
    

                <ng-container matColumnDef="slno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;"> {{paginator.pageSize * paginator.pageIndex + i+1}}   </mat-cell>
                </ng-container>
    
                <!-- Position Column -->
                <ng-container matColumnDef="regno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Register Number </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.RollNumber}} </mat-cell>
                </ng-container>
    
                <!-- Symbol Column -->
                <ng-container matColumnDef="firstname">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> First Name    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.TraineeName}} </mat-cell>
                </ng-container>
    
                 <!-- Symbol Column -->
                 <ng-container matColumnDef="trade">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Trade    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Trade}} </mat-cell>
                </ng-container>
    

                 <!-- Symbol Column -->
                 <ng-container matColumnDef="exam">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Exam    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Exam}} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    
            </mat-table>

            <mat-paginator  #paginator="matPaginator" [pageSize]="5" [length]="totallength" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>
    
            
       
        </div>

        <div class="row pad-tb-10">
     
         
            <div class="col-md-12 align-right">
                <button class="btn btn-success" [disabled]="bool_paynow" (click)="logSelection()"> Pay Now </button>
            </div>

            <p> Before selecting paynow Kindly ensure  that the candidate selected are correct. After selecting paynow changes in selected candidates cannot be made</p>
        </div>


    </div>

    <div class="card-body" *ngIf="bool_Master_table">
        <div class="row pad-tb-10">
            <div class="col-md-10">
                <span class="fnt-21">Verify Your Previous Payment History and Proceed for Payment  </span>
            </div>
           
            <div class="col-md-2 align-right">
                <button class="btn btn-primary" (click)="bcakfn()"> Back </button>
            </div>
        </div>

        <div class="row pad-tb-10">
            <div class="col-md-6">
                Name: {{itiHeaderName}} <br>
                ITI Code: {{itiHeaderCode}} <br>    
            </div>
            <div class="col-md-6">
                Email: {{itiHeaderemail}} <br>
                Mobile: {{itiHeaderMobile}} <br>    
            </div>
        </div>
        <div class="example-container mat-elevation-z8">
            <mat-table #table [dataSource]="dataSource_Master" #sort_Master="matSort" matSort>

                <ng-container matColumnDef="slno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </mat-cell>
                </ng-container>
    
                <!-- Position Column -->
                <!-- <ng-container matColumnDef="iticode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> ITI Code </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
                </ng-container>
     -->
                <!-- <ng-container matColumnDef="itiname">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Name    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.itiname}} </mat-cell>
                </ng-container> -->

                <!-- <ng-container matColumnDef="itiemail">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>  Email </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.itiemail}} </mat-cell>
                </ng-container> -->
    
                <!-- Position Column -->
                <!-- <ng-container matColumnDef="itimobile">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>  Mobile </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.itimobile}} </mat-cell>
                </ng-container>
     -->
                <!-- <ng-container matColumnDef="statename">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> State  </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.statename}} </mat-cell>
                </ng-container> -->
    
                <!-- Position Column -->
                <!-- <ng-container matColumnDef="districtname">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.districtname}} </mat-cell>
                </ng-container> -->
    
                <ng-container matColumnDef="payrefid">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> PayRefID    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.payrefid}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="payrefdate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> PayRefDate </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.payrefdate | date}} </mat-cell>
                </ng-container>
    
                <!-- Position Column -->
                <ng-container matColumnDef="noofstu">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Students </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.noofstu}} <button class="btn btn-success small-btn" (click)="selected_family_member_Master.select(element)" (click)="payMasterView()">View</button> </mat-cell>
                </ng-container>
    
                <ng-container matColumnDef="amount">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Amount    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.amount}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ccaveref">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> CCRefNo </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ccaveref}} </mat-cell>
                </ng-container>
    
                <!-- Position Column -->
                <ng-container matColumnDef="paymentdate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Payment Date </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.paymentdate | date}} </mat-cell>
                </ng-container>                
    
                  <!-- Position Column -->
                  <ng-container matColumnDef="pstatus">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <button class="btn btn-success small-btn" *ngIf="element.pstatus == ''" (click)="selected_family_member_Master.select(element)"  (click)="payMaster()"> {{element.pstatus }}Pay</button>
                        

                        <!-- <button class="btn btn-danger small-btn" *ngIf="element.pstatus == ''" (click)="selected_family_member_Master.select(element)"  (click)="payMasterCancel()"> Cancel </button> -->
                        <span class="btn btn-success small-btn"  *ngIf="element.pstatus == 'DONE' ">PAID</span>
                        <span class="btn btn-primary small-btn" *ngIf="element.pstatus == 'pending'">Pending</span>
                        </mat-cell>
                </ng-container>       

                <!-- Position Column -->
                <!-- <ng-container matColumnDef="upload">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Upload </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <button class="btn btn-success small-btn"*ngIf="element.pstatus == 'DONE'" (click)="selected_family_member_Master.select(element)"  (click)="reverseApi()">Upload to NCVT MIS </button>
                        

                        </mat-cell>
                </ng-container>    -->

                <mat-header-row *matHeaderRowDef="displayedColumnsMaster"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsMaster;  let i = index"></mat-row>
    
            </mat-table>

    
            <!-- <mat-paginator #paginator_Master="matPaginator"  [length]="totallength_master" [pageSizeOptions]="[ 5,10, 25]"></mat-paginator> -->


        </div>

    </div>



</div>


<div class="container-fluid">
    <div class="card-body " *ngIf="bool_popup">
        
        <div class="row pad-tb-10">
            <div class="col-md-12">
                <div class="align-right">
                    <button class="btn btn-danger" (click)="close_fn()" >X</button>
                </div>
            </div>
            <div class="col-md-6">
                Name: {{itiHeaderName}} <br>
                ITI Code: {{itiHeaderCode}} <br>    
            </div>
            <div class="col-md-6">
                Email: {{itiHeaderemail}} <br>
                Mobile: {{itiHeaderMobile}} <br>    
            </div>
        </div>

        <div class="row popup-view">
            <div class="col-md-12">
     
                <table class="popup-table">
                    <tr>
                        <th>#</th>
                        <th>State Name</th>
                        <th>District Name</th>
                        <th>Roll Number</th>
                        <th>Name</th>
                        <th>DOB</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Pay refid</th>
                        <th>Pay refdate</th>
                        <th>Amount</th>                
                        <th>cc ave ref</th>                
                        <th>Payment Date</th>                
                        <th>Status</th>                
                    </tr>
                <tr *ngFor="let column of printView; let i = index;">
                    <td> {{i+1}} </td>
                    <td>{{column.statename}}</td>
                    <td>{{column.districtname}}</td>
                    <td>{{column.rollnumber}}</td>
                    <td>{{column.traineename}}</td>
                    <td>{{column.dob}}</td>
                    <td>{{column.email}}</td>
                    <td>{{column.mobile}}</td>
                    <td>{{column.payrefid}}</td>
                    <td>{{column.payrefdate}}</td>
                    <td>{{column.amount}}</td>
                    <td>{{column.ccaveref}}</td>
                    <td>{{column.paymentdate}}</td>
                    <td>{{column.pstatus}}</td>
        
                </tr>
            </table>
        
            </div>
        </div>

    </div>
</div>

<!-- Modal -->
<!-- <div>

  <div class="modal-content">
    <span class="close">&times;</span>
    <p>Some text in the Modal..</p>
  </div>

</div> -->


 

 